import { type FC, type ReactNode } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'react-bootstrap';

type TradeAllocationSecondaryRedirectButtonProps = {
  label: ReactNode;
  isDisabled?: boolean;
  secondaryActions: { label: string; onClick: () => void }[];
};

export const TradeAllocationSecondaryRedirectButton: FC<TradeAllocationSecondaryRedirectButtonProps> = ({
  label,
  isDisabled = false,
  secondaryActions,
}) => {
  return (
    <Dropdown drop="up" className="my-1">
      <DropdownToggle
        disabled={isDisabled}
        className="btn btn-xl btn-primary btn-icon-start w-100 text-reset text-bg-primary"
      >
        <i className="icon icon-outlined text-bg-primary" aria-hidden="true">
          open_in_new
        </i>
        <span className="text-bg-primary">{label}</span>
      </DropdownToggle>
      <DropdownMenu>
        {secondaryActions.map(action => (
          <DropdownItem
            key={action.label}
            as="button"
            onClick={action.onClick}
            className="d-flex justify-content-between align-items-center"
          >
            {action.label}
            <i className="icon icon-outlined ms-1" aria-hidden="true">
              open_in_new
            </i>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

TradeAllocationSecondaryRedirectButton.displayName = 'TradeAllocationSecondaryRedirectButton';
